var exports = {
  "Vg": "ChatSkeleton.module__grid___WDRNdl",
  "wx": "ChatSkeleton.module__header___WDRNdl",
  "D_": "ChatSkeleton.module__identity___WDRNdl",
  "Ow": "ChatSkeleton.module__identityBack___WDRNdl",
  "um": "ChatSkeleton.module__identityBackDesktop___WDRNdl",
  "W": "ChatSkeleton.module__identityName___WDRNdl",
  "aL": "ChatSkeleton.module__identityCaret___WDRNdl",
  "lf": "ChatSkeleton.module__identityTopicDivider___WDRNdl",
  "$s": "ChatSkeleton.module__headerActions___WDRNdl",
  "QE": "ChatSkeleton.module__headerAction___WDRNdl",
  "YB": "ChatSkeleton.module__headerSearch___WDRNdl",
  "lQ": "ChatSkeleton.module__headerSearchIcon___WDRNdl",
  "Qs": "ChatSkeleton.module__content___WDRNdl",
  "ec": "ChatSkeleton.module__memberListDivider___WDRNdl",
  "oM": "ChatSkeleton.module__chatArea___WDRNdl",
  "JX": "ChatSkeleton.module__chatBody___WDRNdl",
  "DZ": "ChatSkeleton.module__messages___WDRNdl",
  "T_": "ChatSkeleton.module__composerInputLine___WDRNdl",
  "PN": "ChatSkeleton.module__composerAction___WDRNdl",
  "JD": "ChatSkeleton.module__memberList___WDRNdl",
  "Pz": "ChatSkeleton.module__memberListScroller___WDRNdl",
};

module.exports = exports;
